import React from 'react';
import { Outlet } from 'react-router-dom';
import Nav from './Nav.jsx';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C' };

// TODO(M2): Wire cartCount to real cart state (React Context)
const PLACEHOLDER_CART_COUNT = 0;

export default function Layout() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: COLORS.black,
      color: COLORS.white,
      fontFamily: 'Inter, system-ui, sans-serif',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Reset browser defaults inline — in production extract to a global reset */}
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0A0A0A; }
        a { color: inherit; }
        button { cursor: pointer; }
      `}</style>

      <Nav cartCount={PLACEHOLDER_CART_COUNT} />

      {/* Main content area — full bleed, flex grows to push footer down */}
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      <footer style={{
        borderTop: `1px solid rgba(255,255,255,0.08)`,
        padding: '2rem',
        textAlign: 'center',
        fontSize: '0.75rem',
        letterSpacing: '0.12em',
        opacity: 0.4,
        color: COLORS.white,
      }}>
        © {new Date().getFullYear()} QRQY — YOUR LINK. YOUR LOOK.
      </footer>
    </div>
  );
}
